<template>
  <div>
    <v-container grid-list-xl fluid class="pt-0">
      <v-card class="pa-2 mb-3 card-r pb-4 shadow-1 grey lighten-4 ">
        <v-toolbar class="primary mb-3 card-r pl-3 text-white">
          <div class="text-xs-left f-20">Driving Packages</div>
        </v-toolbar>
        <v-btn color="secondary" class="text-white ma-0 card-r" to="createpackage">Add Package</v-btn>
        <!-- <v-btn class="primary text-white ma-0 card-r right" @click="filterPackages()">Import Packages</v-btn> -->

        <v-container fluid grid-list-xl class="pl-0 pr-0">
          <v-layout row wrap class="">
            <v-flex d-flex lg4 sm6 xs12 v-for="(i,index) in adminpackages" :key="`1${index}`">
              <!-- <router-link class="no-deraction" v-bind:to="'viewpackage/'+i.id"> -->
                <v-card class="select-pack-card pa-3 no-shadow card-r shadow-1">
                  <v-toolbar flat xs12 class="transparent">
                    <v-spacer></v-spacer>
                    <v-toolbar-title>
                      <div class="text-xs-center pl-4 f-20 font-weight-bold blue-grey--text">{{i.name}}</div>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <div xs6 class="btn-tool text-xs-right">
                      <v-btn class="ma-0" icon :to="'/EditPackage/'+i.id">
                        <v-icon class="select-pack-color blue-grey--text">edit</v-icon></v-btn>
                    </div>
                    <v-toolbar-items class="hidden-sm-and-down"></v-toolbar-items>
                  </v-toolbar>
                  <v-flex xs12 class="text-xs-right pa-0">
                  </v-flex>
                  <v-layout xs12>
                    <v-flex xs12 class="text-xs-center grey--text pt-0 pb-0">
                      <p class="f-14 word-break">{{i.description}}</p>
                    </v-flex>
                  </v-layout>
                  <!-- <v-layout xs12>
                    <v-flex xs6 class="text-xs-center pa-0">
                      <span class="font-weight-bold f-15 blue-grey--text">Total Hours -</span>
                    </v-flex>
                    <v-flex xs6 class="text-xs-center pa-0">
                      <span class="font-weight-bold f-15">{{i.hours}} Hours</span>
                    </v-flex>
                  </v-layout> -->
                  <v-layout xs12 class="mb-3">
                    <v-flex xs6 class="text-xs-center pa-0">
                      <span class="font-weight-bold f-15 blue-grey--text">Total Cost -</span>
                    </v-flex>
                    <v-flex xs6 class="text-xs-center pa-0">
                      <span class="font-weight-bold f-15">KR {{i.cost}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout xs12>
                    <v-flex xs6 class="text-xs-right pa-0">
                      <!-- <ConfirmDelete/> -->
                      <!--<v-btn icon> <v-icon class="select-pack-color right blue-grey--text">delete</v-icon></v-btn>-->
                    </v-flex>

                  </v-layout>

                  <!--<v-btn class="no-shadow card-r w-100 ma-0 primary text--white btnM">Select</v-btn>-->
                  <!--<v-btn  class="no-shadow card-r w-100 ma-0 primary text&#45;&#45;white btnM">view</v-btn>-->

                </v-card>
              <!-- </router-link> -->
            </v-flex>

          </v-layout>
        </v-container>
        <v-dialog v-model="DownloadPackagePopup" max-width="525">
          <v-card class="no-shadow pa-3">
            <div  class="text-xs-center">
         <span class="f-20">
            Import Classes
           <!-- <v-layout xs12 sm12 class="row">
               <v-flex xs12 sm6 d-flex>
                 <v-select
                   v-model="selectedClub"
                   @change="filterModules()"
                   :items="Clubs"
                   item-text="club_name"
                   item-value="id"
                   label="Clubs"
                   outline
                   type="text"
                 ></v-select>
               </v-flex>
               <v-flex xs12 sm6 d-flex>
                 <v-select
                   v-model="selectedMinute"
                   @change="filterModules()"
                   :items="Minutes"
                   label="Minutes"
                   outline
                   type="text"
                 ></v-select>
               </v-flex>
           </v-layout> -->

         </span>
            </div>
            <v-layout>
              <v-flex>
                <v-flex xs12 class="pt-2">
                  <v-list>
                    <v-card color="lighten-2" class="pt-3 pa-2 card-r no-shadow"  v-if="!loading">
                      <div v-for="val in filteredPackages" v-if="filteredPackages.length!=0">
                        <v-checkbox v-model="selectedPackages" :label="val.name" :value="val.id"></v-checkbox>
                      </div>
                      <div v-if="filteredPackages.length==0">
                        <v-alert
                          :value="true"
                          type="info"
                        >
                          There are no classes found
                        </v-alert>
                      </div>

                    </v-card>
                    <!-- <BulletListLoader v-if="loading" :width="250" :height="100"></BulletListLoader> -->
                    <v-flex xs12 class="text-xs-center mr-1">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        v-if="loading"
                      ></v-progress-circular>
                    </v-flex>
                  </v-list>
                </v-flex>
                <v-flex xs12 class="text-xs-left mr-1">
                  <v-alert v-if="alertType" :type="alertType" :value="true">
                    {{msg}}
                  </v-alert>
                </v-flex>
                <v-layout xs12>
                  <v-flex xs12 class="text-xs-left mr-1">
                    <v-btn @click="DownloadPackagePopup = false" color="grey lighten-2" class="btn-customer card-r">Cancel</v-btn>
                  </v-flex>
                  <v-flex xs12 class="text-xs-right ml-1">
                    <v-btn @click="importPackages(), dialog = false" class="btn-customer card-r primary text-white no-shadow card-r">Import</v-btn>
                  </v-flex>

                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>

        </v-dialog>
      </v-card>
    </v-container>
  </div>
</template>
<style>
  .lll{
    border: 1px solid gray!important;
  }
  .v-dialog{
    box-shadow: none!important;
  }
</style>
<script>
  /* eslint-disable */
  import { mapState , dispatch } from "vuex"
  import ConfirmDelete from './ConfirmDelete'
  import api from "@/utils/backend-api"

  export default {
    components:{
      ConfirmDelete
    },
    data: () => ({
      loading:false,
      show: false,
      dialog: false,
      DownloadPackagePopup:'',
      filteredPackages:[],
      selectedPackages:[],
      PackagesList: "",
      alertType:'',
      msg:'',
      adminpackages:[],
      return: {
        items: [
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg'
          }
        ]
      }
    }),
    created:function(){
      let self=this
      api.postData('driver/viewPackageTemplate')
        .then(res=>{
          self.adminpackages=res.data
        })
    },
    watch:{
      adminpackages:function(){

      }
    },
    methods:{
      loadPopup(){
        // let self=this
        // api.postData('admin/viewOtherClubs')
        // .then(res=>{
        //   self.Clubs=res.data
        // }).catch(err=>{

        // })
        this.loading=true
        this.filterPackages()
        this.DownloadPackagePopup=true
      },

      filterPackages(){
        this.loading=true
        let self=this
        this.DownloadPackagePopup=true
        api.postData('admin/viewPackageTemplate')
          .then(res=>{
            self.filteredPackages=res.data
            this.loading=false
          }).catch(err=>{
          self.filteredPackages=[]
          this.loading=false
        })
        this.selectedPackages=[]
      },


      importPackages(){
        let self=this
        this.loading=true
        api.postData('admin/copyPackage',{package_template_id:this.selectedPackages})
          .then(res=>{
            this.alertType="success"
            this.msg="Successfully imported"
            self.loadClubPackages()
            this.loading=false
            setTimeout(()=>{
              self.DownloadPackagePopup=false
            },1200);
          }).catch(err=>{
          this.loading=false
          this.alertType="error"
          this.msg="Import failed"
        })
      },


      //loadClubPackages()
      loadClubPackages(){
        Store.dispatch("Packages/getAllPackages")
          .then(res => {
            this.PackagesList = res;
            Store.commit("setLoading", { loading: false });
          })
          .catch(() => {
            Store.commit("setLoading", { loading: false });
          });
      },


    },


  }
</script>

<!--<template>-->
  <!--<div>-->
    <!--<v-container grid-list-xl fluid class="pt-0">-->
        <!--<v-card class="pa-3 mb-3 card-r pb-4 shadow-1 grey lighten-4 ">-->
          <!--<v-toolbar class="primary mb-3 card-r pl-3 text-white">-->
            <!--<div class="text-xs-left f-20">My Packages</div>-->
          <!--</v-toolbar>-->
                <!--<v-btn color="secondary" class="text-white ma-0 card-r no-shadow" to="createpackage">Add Package</v-btn>-->
                <!--<v-btn class="primary text-white ma-0 card-r no-shadow right" @click="filterPackages()">Import Packages</v-btn>-->

              <!--<v-container fluid grid-list-xl class="pl-0 pr-0">-->
                <!--<v-layout row wrap class="">-->
                  <!--<v-flex d-flex lg4 sm6 xs12 v-for="(i,index) in adminpackages" :key="`1${index}`">-->
                    <!--<v-card class="select-pack-card pa-3 no-shadow card-r ">-->
                      <!--<v-toolbar flat xs12 class="transparent">-->
                        <!--<v-spacer></v-spacer>-->
                        <!--<v-toolbar-title>-->
                          <!--<div class="text-xs-center pl-4 f-20 font-weight-bold blue-grey&#45;&#45;text">{{i.name}}</div>-->
                        <!--</v-toolbar-title>-->
                        <!--<v-spacer></v-spacer>-->
                        <!--<div xs6 class="btn-tool text-xs-right">-->
                          <!--<v-btn class="ma-0" icon :to="'/EditPackage/'+i.id">-->
                            <!--<v-icon class="select-pack-color blue-grey&#45;&#45;text">edit</v-icon></v-btn>-->
                        <!--</div>-->
                        <!--<v-toolbar-items class="hidden-sm-and-down"></v-toolbar-items>-->
                      <!--</v-toolbar>-->
                      <!--<v-flex xs12 class="text-xs-right pa-0">-->
                      <!--</v-flex>-->
                      <!--<v-layout xs12>-->
                        <!--<v-flex xs12 class="text-xs-center grey&#45;&#45;text pt-0 pb-0">-->
                          <!--<p class="f-14 word-break">{{i.description}}</p>-->
                        <!--</v-flex>-->
                      <!--</v-layout>-->
                      <!--&lt;!&ndash; <v-layout xs12>-->
                        <!--<v-flex xs6 class="text-xs-center pa-0">-->
                          <!--<span class="font-weight-bold f-15 blue-grey&#45;&#45;text">Total Hours -</span>-->
                        <!--</v-flex>-->
                        <!--<v-flex xs6 class="text-xs-center pa-0">-->
                          <!--<span class="font-weight-bold f-15">{{i.hours}} Hours</span>-->
                        <!--</v-flex>-->
                      <!--</v-layout> &ndash;&gt;-->
                      <!--<v-layout xs12 class="mb-3">-->
                        <!--<v-flex xs6 class="text-xs-center pa-0">-->
                          <!--<span class="font-weight-bold f-15 blue-grey&#45;&#45;text">Total Cost -</span>-->
                        <!--</v-flex>-->
                        <!--<v-flex xs6 class="text-xs-center pa-0">-->
                          <!--<span class="font-weight-bold f-15">KR {{i.cost}}</span>-->
                        <!--</v-flex>-->
                      <!--</v-layout>-->
                      <!--<v-layout xs12>-->
                        <!--<v-flex xs6 class="text-xs-right pa-0">-->
                          <!--&lt;!&ndash; <ConfirmDelete/> &ndash;&gt;-->
                          <!--&lt;!&ndash;<v-btn icon> <v-icon class="select-pack-color right blue-grey&#45;&#45;text">delete</v-icon></v-btn>&ndash;&gt;-->
                        <!--</v-flex>-->

                      <!--</v-layout>-->

                      <!--&lt;!&ndash;<v-btn class="no-shadow card-r w-100 ma-0 primary text&#45;&#45;white btnM">Select</v-btn>&ndash;&gt;-->
                      <!--<v-btn v-bind:to="'viewpackage/'+i.id" class="no-shadow card-r bottom-0 w-100 ma-0 primary text&#45;&#45;white btnM">view</v-btn>-->

                    <!--</v-card>-->
                  <!--</v-flex>-->

                <!--</v-layout>-->
              <!--</v-container>-->
          <!--<v-dialog v-model="DownloadPackagePopup" max-width="525">-->
           <!--<v-card class="no-shadow pa-3">-->
        <!--<div  class="text-xs-center">-->
         <!--<span class="f-20">-->
            <!--Import Classes-->
            <!--&lt;!&ndash; <v-layout xs12 sm12 class="row">-->
                <!--<v-flex xs12 sm6 d-flex>-->
                  <!--<v-select-->
                    <!--v-model="selectedClub"-->
                    <!--@change="filterModules()"-->
                    <!--:items="Clubs"-->
                    <!--item-text="club_name"-->
                    <!--item-value="id"-->
                    <!--label="Clubs"-->
                    <!--outline-->
                    <!--type="text"-->
                  <!--&gt;</v-select>-->
                <!--</v-flex>-->
                <!--<v-flex xs12 sm6 d-flex>-->
                  <!--<v-select-->
                    <!--v-model="selectedMinute"-->
                    <!--@change="filterModules()"-->
                    <!--:items="Minutes"-->
                    <!--label="Minutes"-->
                    <!--outline-->
                    <!--type="text"-->
                  <!--&gt;</v-select>-->
                <!--</v-flex>-->
            <!--</v-layout> &ndash;&gt;-->

         <!--</span>-->
        <!--</div>-->
        <!--<v-layout>-->
          <!--<v-flex>-->
                <!--<v-flex xs12 class="pt-2">-->
                  <!--<v-list>-->
                    <!--<v-card color="lighten-2" class="pt-3 pa-2 card-r no-shadow"  v-if="!loading">-->
                      <!--<div v-for="val in filteredPackages" v-if="filteredPackages.length!=0">-->
                        <!--<v-checkbox v-model="selectedPackages" :label="val.name" :value="val.id"></v-checkbox>-->
                      <!--</div>-->
                      <!--<div v-if="filteredPackages.length==0">-->
                           <!--<v-alert-->
                              <!--:value="true"-->
                              <!--type="info"-->
                            <!--&gt;-->
                              <!--There are no classes found-->
                            <!--</v-alert>-->
                      <!--</div>-->

                    <!--</v-card>-->
                    <!--&lt;!&ndash; <BulletListLoader v-if="loading" :width="250" :height="100"></BulletListLoader> &ndash;&gt;-->
                <!--<v-flex xs12 class="text-xs-center mr-1">-->
                    <!--<v-progress-circular-->
                      <!--indeterminate-->
                      <!--color="primary"-->
                      <!--v-if="loading"-->
                    <!--&gt;</v-progress-circular>-->
                <!--</v-flex>-->
                  <!--</v-list>-->
                <!--</v-flex>-->
                <!--<v-flex xs12 class="text-xs-left mr-1">-->
                  <!--<v-alert v-if="alertType" :type="alertType" :value="true">-->
                        <!--{{msg}}-->
                  <!--</v-alert>-->
                <!--</v-flex>-->
                <!--<v-layout xs12>-->
                  <!--<v-flex xs12 class="text-xs-left mr-1">-->
                    <!--<v-btn @click="DownloadPackagePopup = false" color="grey lighten-2" class="btn-customer card-r">Cancel</v-btn>-->
                  <!--</v-flex>-->
                  <!--<v-flex xs12 class="text-xs-right ml-1">-->
                    <!--<v-btn @click="importPackages(), dialog = false" class="btn-customer card-r primary text-white no-shadow card-r">Import</v-btn>-->
                  <!--</v-flex>-->

                <!--</v-layout>-->
          <!--</v-flex>-->
        <!--</v-layout>-->
      <!--</v-card>-->

  <!--</v-dialog>-->
        <!--</v-card>-->
    <!--</v-container>-->
  <!--</div>-->
<!--</template>-->
<!--<style>-->
<!--.lll{-->
  <!--border: 1px solid gray!important;-->
<!--}-->
<!--.v-dialog{-->
  <!--box-shadow: none!important;-->
<!--}-->
<!--</style>-->
<!--<script>-->
  <!--/* eslint-disable */-->
  <!--import { mapState , dispatch } from "vuex"-->
  <!--import ConfirmDelete from './ConfirmDelete'-->
  <!--import api from "@/utils/backend-api"-->

  <!--export default {-->
    <!--components:{-->
      <!--ConfirmDelete-->
    <!--},-->
    <!--data: () => ({-->
      <!--loading:false,-->
      <!--show: false,-->
      <!--dialog: false,-->
      <!--DownloadPackagePopup:'',-->
      <!--filteredPackages:[],-->
      <!--selectedPackages:[],-->
      <!--PackagesList: "",-->
      <!--alertType:'',-->
      <!--msg:'',-->
      <!--adminpackages:[],-->
      <!--return: {-->
        <!--items: [-->
          <!--{-->
            <!--src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg'-->
          <!--},-->
          <!--{-->
            <!--src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg'-->
          <!--},-->
          <!--{-->
            <!--src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg'-->
          <!--},-->
          <!--{-->
            <!--src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg'-->
          <!--}-->
        <!--]-->
      <!--}-->
    <!--}),-->
    <!--created:function(){-->
        <!--let self=this-->
        <!--api.postData('driver/viewPackageTemplate')-->
        <!--.then(res=>{-->
          <!--self.adminpackages=res.data-->
        <!--})-->
    <!--},-->
    <!--watch:{-->
      <!--adminpackages:function(){-->

      <!--}-->
    <!--},-->
    <!--methods:{-->
    <!--loadPopup(){-->
      <!--// let self=this-->
      <!--// api.postData('admin/viewOtherClubs')-->
      <!--// .then(res=>{-->
      <!--//   self.Clubs=res.data-->
      <!--// }).catch(err=>{-->

      <!--// })-->
      <!--this.loading=true-->
      <!--this.filterPackages()-->
      <!--this.DownloadPackagePopup=true-->
    <!--},-->

    <!--filterPackages(){-->
      <!--this.loading=true-->
      <!--let self=this-->
      <!--this.DownloadPackagePopup=true-->
      <!--api.postData('admin/viewPackageTemplate')-->
      <!--.then(res=>{-->
            <!--self.filteredPackages=res.data-->
            <!--this.loading=false-->
      <!--}).catch(err=>{-->
            <!--self.filteredPackages=[]-->
            <!--this.loading=false-->
      <!--})-->
      <!--this.selectedPackages=[]-->
    <!--},-->


    <!--importPackages(){-->
      <!--let self=this-->
      <!--this.loading=true-->
      <!--api.postData('admin/copyPackage',{package_template_id:this.selectedPackages})-->
      <!--.then(res=>{-->
            <!--this.alertType="success"-->
            <!--this.msg="Successfully imported"-->
            <!--self.loadClubPackages()-->
            <!--this.loading=false-->
            <!--setTimeout(()=>{-->
              <!--self.DownloadPackagePopup=false-->
            <!--},1200);-->
      <!--}).catch(err=>{-->
            <!--this.loading=false-->
            <!--this.alertType="error"-->
            <!--this.msg="Import failed"-->
      <!--})-->
    <!--},-->


    <!--//loadClubPackages()-->
    <!--loadClubPackages(){-->
      <!--Store.dispatch("Packages/getAllPackages")-->
      <!--.then(res => {-->
        <!--this.PackagesList = res;-->
        <!--Store.commit("setLoading", { loading: false });-->
      <!--})-->
      <!--.catch(() => {-->
        <!--Store.commit("setLoading", { loading: false });-->
      <!--});-->
    <!--},-->


    <!--},-->


  <!--}-->
<!--</script>-->



// WEBPACK FOOTER //
// src/pages/pages/package/Packages.vue